<template>
    <FilterMultiSelect
        :selections="value"
        placeholder="Select Top Issue(s)"
        :options="topIssues"
        @handleSelection="$emit('handleValueChange', $event)"
    />
</template>

<script>
import { TopIssues } from '@/store/constants';
import FilterMultiSelect from '@/components/common/FilterMultiSelect.vue';

export default {
    components: {
        FilterMultiSelect,
    },
    name: 'TopIssueRule',
    props: ['value'],
    data() {
        return {
            topIssues: TopIssues,
        };
    },
};
</script>

<style scoped></style>
